
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CheckListDialog extends Serenity.EntityDialog<CheckListRow, any> {
        protected getFormKey() { return CheckListForm.formKey; }
        protected getIdProperty() { return CheckListRow.idProperty; }
        protected getLocalTextPrefix() { return CheckListRow.localTextPrefix; }
        protected getNameProperty() { return CheckListRow.nameProperty; }
        protected getService() { return CheckListService.baseUrl; }
        protected getDeletePermission() { return CheckListRow.deletePermission; }
        protected getInsertPermission() { return CheckListRow.insertPermission; }
        protected getUpdatePermission() { return CheckListRow.updatePermission; }

        protected form = new CheckListForm(this.idPrefix);

    }
}